import React, { PropTypes, Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ClassNames from 'classnames';
import { GridContainer, GridCell } from 'components/Grid/Grid';
import { TextField, FontIcon, FlatButton } from 'material-ui';

export default class SelectableList extends Component {
  constructor() {
    super(...arguments);
    let selected = {},
      idProperty = this.props.idProperty,
      selectedCount = 0,
      labelProperty = this.props.labelProperty;

    this.props.preSelected.map(item => {
      selectedCount++;
      selected[item[idProperty]] = item[labelProperty];
    });
    if (this.props.onSelect && selectedCount > 0) {
      this.props.onSelect(selected, selectedCount);
    }
    this.state = {
      searchText: null,
      selectedCount,
      selected
    };
  }

  static propTypes = {
    searchHint: PropTypes.string,
    singleChoice: PropTypes.bool,
    list: PropTypes.array.isRequired,
    labelProperty: PropTypes.string,
    selectProperty: PropTypes.string,
    idProperty: PropTypes.string,
    preSelected: PropTypes.array,
    controls: PropTypes.bool,
    searchBar: PropTypes.bool,
    summary: PropTypes.bool,
    onSelect: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  static defaultProps = {
    singleChoice: false,
    labelProperty: 'name',
    selectProperty: 'name',
    idProperty: 'id',
    searchHint: 'Search',
    preSelected: [],
    searchBar: true,
    summary: true,
    controls: false
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  onSearchTextChange(event) {
    let timerId = this.timerId;
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      let searchText = null,
        fieldValue = this.refs.searchField.getValue();
      if (fieldValue !== '') {
        searchText = fieldValue.toUpperCase();
      }
      this.setState({ searchText });
    }, 500);
    this.timerId = timerId;
  }
  selectItem(item) {
    let selected,
      id = item[this.props.idProperty],
      selectedCount = this.state.selectedCount,
      selectedLabel = item[this.props.selectProperty];
    if (this.props.singleChoice) {
      selected = {};
      selectedCount = 0;
    } else {
      selected = this.state.selected;
    }
    if (selected[id]) {
      delete selected[id];
    } else {
      selected[id] = selectedLabel;
    }
    if (selected[id]) {
      selectedCount = selectedCount + 1;
    } else {
      selectedCount = selectedCount - 1;
    }
    this.setState({ selected, selectedCount, selectedLabel });
    if (this.props.onSelect) {
      this.props.onSelect(this.state.selected, selectedCount);
    }
  }

  markAll(markSelected) {
    let items,
      selected = this.state.selected,
      searchText = this.state.searchText,
      idProperty = this.props.idProperty,
      labelProperty = this.props.labelProperty,
      selectProperty = this.props.selectProperty,
      selectedCount = 0,
      selectedList = [];
    markSelected = !!markSelected;

    if (markSelected) {
      this.props.list.map(item => {
        if (
          searchText === null ||
          item[this.props.labelProperty].toUpperCase().search(searchText) > -1
        ) {
          selected[item[idProperty]] = item[selectProperty];
          selectedCount++;
        }
      });
    } else {
      selected = {};
      selectedCount = 0;
    }
    this.setState({ selected, selectedCount });
    if (this.props.onSelect) {
      this.props.onSelect(this.state.selected, selectedCount);
    }
  }

  renderControls() {
    if (!this.props.searchBar && !this.props.controls) {
      return null;
    } else {
      let children = [];
      if (this.props.searchBar) {
        children.push(
          <GridCell size={12} key={1}>
            <div className="search-bar">
              <TextField
                icon={'md md-search'}
                hintText={this.props.searchHint}
                ref="searchField"
                onChange={this.onSearchTextChange.bind(this)}
              />
            </div>
          </GridCell>
        );
      }
      if (this.props.controls) {
        children.push(
          <GridCell size={6} key={2}>
            <div className="input-wrapper">
              <FlatButton
                label={this.context.getIntlMessage('selectAll')}
                onTouchTap={this.markAll.bind(this, true)}
              />
            </div>
          </GridCell>
        );
        children.push(
          <GridCell size={6} key={3}>
            <div className="input-wrapper">
              <FlatButton
                label={this.context.getIntlMessage('deselectAll')}
                onTouchTap={this.markAll.bind(this, false)}
              />
            </div>
          </GridCell>
        );
      }
      return (
        <GridContainer fluid={true} className="controls">
          {children}
        </GridContainer>
      );
    }
  }

  renderSummary() {
    let summary = null;
    if (this.state.selectedCount > 0) {
      summary = (
        <FormattedMessage
          message={this.context.getIntlMessage('selectedCount')}
          num={this.state.selectedCount}
        />
      );
    } else {
      return null;
    }
    return <div className="summary">{summary}</div>;
  }

  render() {
    let items, children, controls, summary, classes, title;
    let list = this.props.list || [];

    items = list.filter(item => {
      let searchText = this.state.searchText;
      return (
        searchText === null ||
        item[this.props.labelProperty].toUpperCase().search(searchText) > -1
      );
    });
    children = items.map(item => {
      let id = item[this.props.idProperty],
        selected = this.state.selected[id],
        itemClasses = ClassNames('list-item', {
          selected
        }),
        selectedItem = null;
      if (selected) {
        selectedItem = (
          <div className="check">
            <FontIcon className="md md-done" />
          </div>
        );
      }
      return (
        <div
          key={id}
          className={itemClasses}
          onTouchTap={this.selectItem.bind(this, item)}
        >
          {item[this.props.labelProperty]}
          {selectedItem}
        </div>
      );
    });
    controls = this.renderControls();
    summary = this.renderSummary();
    classes = ClassNames('selectable-list', this.props.className, {
      'has-summary': this.props.summary && !!summary
    });
    title =
      typeof this.props.title === 'string' ? (
        <h1>{this.props.title}</h1>
      ) : (
        this.props.title
      );
    return (
      <div className={classes}>
        <div className="list-wrapper">
          {title}
          {controls}
          <div className="list">{children}</div>
        </div>
        {summary}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/SelectableList.js